import TripEditorContainer from './TripEditorContainer';

export default TripEditorContainer;
